import { HTTP_STATUS_FORBIDDEN, HTTP_STATUS_UNAUTHORIZED } from '~/lib/utils/http_status';

export {
  CRITICAL,
  HIGH,
  MEDIUM,
  LOW,
  INFO,
  UNKNOWN,
  SEVERITIES,
} from '~/vulnerabilities/constants';

export const LOADING_VULNERABILITIES_ERROR_CODES = {
  UNAUTHORIZED: HTTP_STATUS_UNAUTHORIZED,
  FORBIDDEN: HTTP_STATUS_FORBIDDEN,
};
